import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";

const useDetachOrderMutation = (clockId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["detachOrder", clockId],
    mutationFn: (orderName: string) =>
      adminApiClient.detachOrder(clockId, orderName),
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: ["machine", clockId] }),
  });
};

export default useDetachOrderMutation;
